export const environmentversion = {
  version : 'origin/Dev1.0(81558d9744d45b0566d2e63e3e37588a225d883b)'
};